
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.4 9.43c-.1-.4-.44-.69-.85-.74l-7.58-.86-2.55-6.76c-.15-.39-.52-.65-.94-.65-.42 0-.79.26-.94.65L8.99 7.83l-7.68.85c-.41.05-.75.34-.86.74-.1.4.05.83.39 1.07l5.86 4.17-2.55 8.48c-.12.4.02.83.35 1.08.33.25.78.28 1.14.06l6.84-4.25 6.84 4.25a1.002 1.002 0 001.14-.06c.33-.25.47-.68.35-1.08l-2.56-8.48 5.76-4.15c.34-.24.49-.66.38-1.06l.01-.02z"}})])
          )
        }
      }
    